import { useCallback, useEffect } from 'react';
import { useLazyIsPaymentInfoValidQuery } from '../api/billingApiSlice';
import {
  openChargebeePortalBillingAddress,
  openChargebeePortalPaymentSources,
  initChargebee,
} from '../../../chargebee/chargebee';

export const usePaymentChargebeeInfo = () => {
  const [triggerIsPaymentInfoValid] = useLazyIsPaymentInfoValidQuery();

  useEffect(() => {
    triggerIsPaymentInfoValid();

    const url = window.location.href;
    initChargebee(url);
  }, []);

  const onChangeBillingAddress = useCallback(() => {
    openChargebeePortalBillingAddress({
      onClosed: () => {
        triggerIsPaymentInfoValid();
      },
    });
  }, [triggerIsPaymentInfoValid]);

  const onChangePaymentMethod = useCallback(() => {
    openChargebeePortalPaymentSources({
      onPaymentSourceAdded: () => {
        triggerIsPaymentInfoValid();
      },
      paymentSourceUpdate: () => {
        triggerIsPaymentInfoValid();
      },
      onClosed: () => {
        triggerIsPaymentInfoValid();
      },
    });
  }, [triggerIsPaymentInfoValid]);

  return {
    onChangeBillingAddress,
    onChangePaymentMethod,
  };
};
